'use client';

import { useState, useEffect, useRef } from 'react';
import { lang, hocTranslateServerClient } from '@/helpers/translate';
import { getRootUrl } from '@/helpers/router';

function Discovery({ t, locale, ...props }) {
  const langCurrent = locale || lang();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const trad = t('header:discovery');
  const [categories] = useState((trad?.category || '').split(','));

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  function renderContent() {
    const halfLength = Math.ceil(categories.length / 2);
    const firstHalf = categories.slice(0, halfLength);
    const secondHalf = categories.slice(halfLength);

    return (
      <div className="w-80v md:max-w-[460px] p-6 md:px-7 md:py-5 text-left flex gap-x-8 text-sm">
        <div className="flex-1">
          {firstHalf.map((cate) => {
            const cateData = trad?.[cate] || {};
            const items = cateData?.items?.split('|') || [];
            return (
              <div className="mb-10" key={`headerkeydiscoverylink2liroot${cate}`}>
                <h3 className="font-medium text-purple-6">{cateData?.title}</h3>
                <ul className="my-2">
                  {items.map((item) => {
                    const [slugItem, titleItem] = item.split(',');
                    return (
                      <li className="mb-1" key={`headerkeydiscoverylink2li${getRootUrl(langCurrent)}/${cateData.slug}/${slugItem}`}>
                        <a
                          href={`${getRootUrl(langCurrent)}/${cateData.slug}/${slugItem}`}
                          className="block text-purple-5/70 hover:text-purple-6"
                          onClick={() => setIsOpen(false)}
                        >
                          {titleItem}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
        <div className="flex-1">
          {secondHalf.map((cate) => {
            const cateData = trad?.[cate] || {};
            const items = cateData?.items?.split('|') || [];
            return (
              <div key={`headerkeydiscoverylink2liroot${cate}`}>
                <h3 className="font-medium text-purple-6">{cateData?.title}</h3>
                <ul className="my-2">
                  {items.map((item) => {
                    const [slugItem, titleItem] = item.split(',');
                    return (
                      <li className="mb-1" key={`headerkeydiscoverylink2li${getRootUrl(langCurrent)}/${cateData.slug}/${slugItem}`}>
                        <a
                          href={`${getRootUrl(langCurrent)}/${cateData.slug}/${slugItem}`}
                          className="block text-purple-5/70 hover:text-purple-6"
                          onClick={() => setIsOpen(false)}
                        >
                          {titleItem}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className="text-base transition-colors duration-200 rounded-lg cursor-pointer lg:font-light lg:px-4 lg:py-2 text-purple-4 hover:text-purple-1 top"
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        {trad?.title}
      </div>
      <div
        className={`absolute z-50 mt-2 bg-white rounded-lg shadow-lg backdrop-blur-sm border border-purple-1/10
          transition-all duration-150 ease-out
          ${isOpen
            ? 'opacity-100 visible'
            : 'opacity-0 invisible'}`}
        style={{
          transitionDelay: isOpen ? '0ms' : '100ms',
          transform: isOpen ? 'translateY(0)' : 'translateY(-10px)',
        }}
      >
        {renderContent()}
      </div>
    </div>
  );
}

export default hocTranslateServerClient(Discovery);
